/* ── Shared inline styles ── */
// `inp` — base style for text/number inputs across forms + modals.
// Extracted from App.jsx (C1 Phase 2c) to break the App.jsx <-> NameCombo.jsx
// circular import. Pure style object, zero interpolation — behavior-preserving move.
export const inp = {
  width: "100%", padding: "11px 15px", background: "#FFFFFF",
  border: "2px solid #E2E8F0", borderRadius: 12,
  color: "#0F172A", fontSize: 14, outline: "none", boxSizing: "border-box",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
};
